export default {
      id: "manage-icon-usage",
      viewBox: "0 0 29 28",
      url: __webpack_public_path__ + "sprite.svg#manage-icon",
      toString: function () {
        return this.url;
      }
    }